import React from 'react'
import { FieldWrapper, FieldTitle } from '../Field'
import DualLabelSwitch from '../DualLabelSwitch'
type FraudIndicatorsActivatorProps = {
  title: string
  description: string
  selected: boolean
  setSelected: (value: boolean) => void
}

const FraudIndicatorsActivator = ({
  title,
  description,
  selected,
  setSelected,
}: FraudIndicatorsActivatorProps) => {
  return (
    <FieldWrapper>
      <FieldTitle title={title} description={description} />
      <DualLabelSwitch
        checked={selected}
        onChange={(_, checked) => setSelected(checked)}
      />
    </FieldWrapper>
  )
}

export default FraudIndicatorsActivator
